var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_128",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 43
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.191406,
    y: 0.851562,
    width: 41.176,
    height: 41.1522,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3674 17.4881C41.3674 20.0982 41.3674 22.7109 41.3674 25.321C41.3549 25.3811 41.3348 25.4413 41.3298 25.5039C41.2922 26.1026 41.2647 26.7037 41.2196 27.2999C41.177 27.856 41.1269 28.4121 41.0518 28.9632C40.9942 29.389 40.8814 29.8074 40.8188 30.2332C40.6961 31.0548 40.4531 31.8313 40.0172 32.5402C39.7317 33.0011 39.381 33.412 38.9602 33.7576C38.4617 34.1659 37.9206 34.5266 37.2944 34.6794C36.6481 34.8373 35.9868 34.9525 35.3255 35.0076C33.7549 35.1379 32.1793 35.2681 30.6062 35.3157C28.0938 35.3909 25.5813 35.4209 23.0689 35.4359C20.5764 35.451 18.084 35.4409 15.5916 35.4059C13.7204 35.3783 11.8518 35.3257 9.98308 35.2255C8.66298 35.1554 7.34789 34.9876 6.0303 34.8598C5.44665 34.8022 4.89055 34.6268 4.39207 34.3388C3.76333 33.9731 3.20473 33.5172 2.75885 32.916C2.35055 32.3649 2.03242 31.7737 1.88213 31.1224C1.6642 30.1881 1.49135 29.2387 1.38364 28.2844C1.2584 27.1697 1.17824 26.0449 1.16321 24.9227C1.13064 22.5982 1.14818 20.2736 1.1582 17.949C1.16071 17.3628 1.20078 16.7767 1.25339 16.193C1.33354 15.3188 1.42122 14.4446 1.54396 13.5754C1.65919 12.7513 1.77441 11.9296 2.09254 11.1431C2.50084 10.1386 3.13459 9.32701 4.04639 8.74837C4.41211 8.51792 4.80538 8.29247 5.2187 8.18226C5.86998 8.01192 6.5413 7.89669 7.21263 7.84159C8.76318 7.71133 10.3162 7.58609 11.8693 7.53849C14.269 7.46334 16.6713 7.43078 19.0735 7.41825C21.8865 7.40573 24.7021 7.41575 27.5151 7.45082C29.1909 7.47086 30.8642 7.53348 32.5375 7.62366C33.7274 7.68879 34.9147 7.82906 36.102 7.93427C37.0414 8.01693 37.9131 8.29748 38.6746 8.8636C39.0804 9.16419 39.4336 9.51989 39.7467 9.92569C40.0849 10.3616 40.3429 10.8325 40.5107 11.3435C40.6585 11.7894 40.7437 12.2603 40.8313 12.7237C40.9491 13.3524 41.0718 13.9812 41.1369 14.6149C41.2271 15.4816 41.2647 16.3534 41.3273 17.2251C41.3323 17.3127 41.3524 17.4004 41.3674 17.4881ZM28.8227 21.0401C24.5593 18.8157 20.3435 16.6164 16.1026 14.4045C16.1026 18.8307 16.1026 23.2119 16.1026 27.6331C20.3435 25.4362 24.5518 23.2544 28.8227 21.0401Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/YT.6720c816214a52544e987a6ac2451cdd.svg";
export { ForwardRef as ReactComponent };